var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.744,
    height: 31.553,
    viewBox: "0 0 30.744 31.553",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendario",
    transform: "translate(-106.667 -64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7372",
    "data-name": "Trazado 7372",
    d: "M106.667,318.084V298.667h30.744v19.417a3.246,3.246,0,0,1-3.236,3.236H109.9a3.246,3.246,0,0,1-3.236-3.236Z",
    transform: "translate(0 -225.767)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7373",
    "data-name": "Trazado 7373",
    d: "M137.411,131.236v4.854H106.667v-4.854A3.246,3.246,0,0,1,109.9,128h24.272a3.246,3.246,0,0,1,3.236,3.236Z",
    transform: "translate(0 -61.573)",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7374",
    "data-name": "Trazado 7374",
    d: "M642.427,151.76m-2.427,0a2.427,2.427,0,1,0,2.427-2.427A2.427,2.427,0,0,0,640,151.76Z",
    transform: "translate(-513.107 -82.097)",
    fill: "#b71c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7375",
    "data-name": "Trazado 7375",
    d: "M258.427,151.76m-2.427,0a2.427,2.427,0,1,0,2.427-2.427A2.427,2.427,0,0,0,256,151.76Z",
    transform: "translate(-143.67 -82.097)",
    fill: "#b71c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7376",
    "data-name": "Trazado 7376",
    d: "M293.514,64a1.623,1.623,0,0,0-1.618,1.618v4.045a1.618,1.618,0,0,0,3.236,0V65.618A1.623,1.623,0,0,0,293.514,64Zm-14.563,0a1.623,1.623,0,0,0-1.618,1.618v4.045a1.618,1.618,0,0,0,3.236,0V65.618A1.623,1.623,0,0,0,278.951,64Z",
    transform: "translate(-164.194)",
    fill: "#b0bec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7377",
    "data-name": "Trazado 7377",
    d: "M277.333,426.667h3.236V429.9h-3.236Zm4.854,0h3.236V429.9h-3.236Zm4.854,0h3.236V429.9h-3.236Zm4.854,0h3.236V429.9H291.9Zm-14.563,4.854h3.236v3.236h-3.236Zm4.854,0h3.236v3.236h-3.236Zm4.854,0h3.236v3.236h-3.236Zm4.854,0h3.236v3.236H291.9Zm-14.563,4.854h3.236v3.236h-3.236Zm4.854,0h3.236v3.236h-3.236Zm4.854,0h3.236v3.236h-3.236Zm4.854,0h3.236v3.236H291.9Z",
    transform: "translate(-164.194 -348.913)",
    fill: "#90a4ae"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.0a7bb18b8bacaf7dd3d204f2f0f2e061.svg";
export { ForwardRef as ReactComponent };